class PopsicleDrawer extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-drawer-trigger]');
    this.panel = this.querySelector('[data-drawer-panel]');
    this.closeButton = this.querySelector('[data-drawer-close]');
    this.backdrop = this.querySelector('[data-drawer-backdrop]');
    if (!this.trigger || !this.panel) return;
    this.trigger.addEventListener('click', () => this.open());
    this.closeButton?.addEventListener('click', () => this.close());
    this.backdrop?.addEventListener('click', () => this.close());
    this.panel.addEventListener('click', event => { if (event.target === this.panel) this.close(); });
    document.addEventListener('keydown', event => { if (event.key === 'Escape') this.close(); });
  }
  open() { this.setAttribute('open', ''); this.trigger.setAttribute('aria-expanded', 'true'); document.body.classList.add('drawer-open'); this.closeButton?.focus(); }
  close() { this.removeAttribute('open'); this.trigger.setAttribute('aria-expanded', 'false'); document.body.classList.remove('drawer-open'); this.trigger.focus(); }
}
customElements.define('popsicle-drawer', PopsicleDrawer);

class PopsicleAgeGate extends HTMLElement {
  connectedCallback() {
    if (sessionStorage.getItem('popsicle-age-verified') === 'yes') return this.remove();
    this.hidden = false;
    document.body.classList.add('age-gate-open');
    this.querySelector('[data-age-yes]')?.addEventListener('click', () => {
      sessionStorage.setItem('popsicle-age-verified', 'yes');
      document.body.classList.remove('age-gate-open');
      this.remove();
    });
  }
}
customElements.define('popsicle-age-gate', PopsicleAgeGate);

document.addEventListener('click', event => {
  const button = event.target.closest('[data-quantity-step]');
  if (!button) return;
  const input = button.parentElement.querySelector('input[type="number"]');
  if (!input) return;
  const step = Number(button.dataset.quantityStep);
  input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
